import { useState } from "react";
import { useAuth, formatApiErrorDetail } from "@/auth/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function ChangePasswordModal({ open, onOpenChange, force = false }) {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) {
      setError("La nueva contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (next !== confirm) {
      setError("Las dos contraseñas nuevas no coinciden.");
      return;
    }
    setLoading(true);
    try {
      await changePassword(current, next);
      setCurrent(""); setNext(""); setConfirm("");
      onOpenChange(false);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={force ? undefined : onOpenChange}>
      <DialogContent
        data-testid="change-password-modal"
        className={`max-w-md ${force ? "[&>button.absolute]:hidden" : ""}`}
        onInteractOutside={force ? (e) => e.preventDefault() : undefined}
        onEscapeKeyDown={force ? (e) => e.preventDefault() : undefined}
      >
        <DialogHeader>
          <DialogTitle>Cambia tu contraseña temporal</DialogTitle>
          <DialogDescription>
            {force
              ? "Por seguridad, define una contraseña personal antes de continuar."
              : "Actualiza tu contraseña por una más segura."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1">
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Contraseña actual</Label>
            <Input data-testid="cp-current-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="rounded-md" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Nueva contraseña</Label>
            <Input data-testid="cp-new-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} required className="rounded-md" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Repite la nueva contraseña</Label>
            <Input data-testid="cp-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="rounded-md" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="cp-error">{error}</p>}
          <Button data-testid="cp-submit-button" type="submit" disabled={loading} className="w-full rounded-md font-semibold">
            {loading ? <span className="flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Guardando…</span> : "Cambiar contraseña"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
